import IkeaLoading, { LoadingBall as IngkaLoadingBall } from '@ingka/loading';
import classNames from 'classnames';
import ScrollToTop from 'Common/ScrollToTop';
import CONFIG from 'Config/settings';
import PropTypes from 'prop-types';
import React from 'react';
import './Loading.scss';

export class Loading extends React.PureComponent {
  render() {
    return (
      <ScrollToTop>
        <div
          className={classNames(this.props.className)}
          style={{
            height: '75vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IkeaLoading prefix={CONFIG.APP.STYLES_PREFIX} text={this.props.text}>
            {this.props.showLoadingBall && (
              <IngkaLoadingBall
                prefix={CONFIG.APP.STYLES_PREFIX}
                color="emphasised"
              />
            )}
          </IkeaLoading>
        </div>
      </ScrollToTop>
    );
  }
}

Loading.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  showLoadingBall: PropTypes.bool
};
